import React from 'react'

function AdvisorGroup() {

    return (
        <div>
            <p>
                Securities America is part of the Advisor Group, one of the largest networks of independent
                wealth management firms in the United States, with more than 11,000 affiliated financial
                professionals. Their firm invests significant resources across our network, so financial
                professionals can have access to state-of-the-art technologies, personalized service, and broad-
                based operational support to better serve our clients.
            </p>
        </div>
    )
}
export default AdvisorGroup